var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7545 0H4.24551C1.90504 0 0 1.91217 0 4.26444V20.7356C0 23.0865 1.90515 25 4.24551 25H29.7545C32.095 25 34 23.0864 34 20.7356V4.26444C34 1.91206 32.0948 0 29.7545 0V0ZM4.24551 1.20807H29.7545C30.8332 1.20807 31.7792 1.77579 32.3193 2.62663L19.2371 15.0378C18.0034 16.2073 15.9979 16.2073 14.7641 15.0378L1.68041 2.62663C2.22053 1.77579 3.16793 1.20807 4.24521 1.20807H4.24551ZM1.2321 21.1376C1.21439 21.0057 1.20258 20.8723 1.20258 20.7359V4.26482C1.20258 4.12845 1.21439 3.99504 1.2321 3.86312L10.3359 12.5005L1.2321 21.1376ZM29.7546 23.7924H4.24567C3.16691 23.7924 2.22098 23.2247 1.68087 22.3739L11.2123 13.3304L13.9379 15.9155C14.782 16.716 15.8903 17.1177 17 17.1177C18.1083 17.1177 19.218 16.7175 20.0621 15.9155L22.7878 13.3304L32.3192 22.3723C31.7791 23.2247 30.8317 23.7924 29.7544 23.7924L29.7546 23.7924ZM32.7976 4.26471V20.7358C32.7976 20.8722 32.7858 21.0056 32.768 21.1375L23.6643 12.5001L32.7696 3.8627C32.7858 3.99463 32.7976 4.12803 32.7976 4.2644L32.7976 4.26471Z",
    fill: "#143CFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.0cefc0ab3bea2d40e9be671f1752cd30.svg";
export { ForwardRef as ReactComponent };